<template>
  <v-navigation-drawer
    id="nav-drawer"
    v-model="inputValue"
    :class="{ mini }"
    :mini-variant="mini"
    mini-variant-width="50"
    clipped
    fixed
    permanent
    style="z-index: 101;"
    @mouseenter.native="expandDrawer"
    @mouseleave.native="collapseDrawer"
  >
    <v-list class="pa-1">
      <v-list-tile avatar tag="div">
        <v-list-tile-avatar>
          <img :src="loggedUser.profile_photo_url" />
        </v-list-tile-avatar>
        <v-list-tile-content>
          <v-list-tile-title>{{ loggedUser.name }}</v-list-tile-title>
        </v-list-tile-content>
      </v-list-tile>
    </v-list>

    <v-divider class="mx-2" light></v-divider>

    <v-list class="pa-0" dense v-for="(link, i) in links" :key="i">
      <v-list-group
        v-if="link.group"
        :prepend-icon="link.icon"
        :value="openGroupIndex === i"
        class="menu-group-active"
        @input="onGroupInput(i, $event)"
      >
        <template v-slot:activator>
          <v-list-tile class="pa-1 ma-0" style="margin: 25px 0 0 0">
            <v-list-tile-title>{{ link.text[0] }}</v-list-tile-title>
          </v-list-tile>
        </template>
        <v-list-tile
          class="pa-1 ma-0"
          style="margin: 25px 0 0 0"
          v-for="(children, j) in link.children"
          :key="j"
          :to="children.to"
          :class="active(children.text)"
        >
          <v-list-tile-action>
            <v-icon v-text="children.icon"></v-icon>
          </v-list-tile-action>
          <v-list-tile-title v-text="children.text[0]"></v-list-tile-title>
        </v-list-tile>
      </v-list-group>
      <v-list-tile
        v-else
        class="pa-1 ma-0"
        style="margin: 25px 0 0 0"
        :to="link.to"
        :class="active(link.text)"
      >
        <v-list-tile-action>
          <v-icon>{{ link.icon }}</v-icon>
        </v-list-tile-action>
        <v-list-tile-content>
          <v-list-tile-title>{{ link.text[0] }}</v-list-tile-title>
        </v-list-tile-content>
      </v-list-tile>
    </v-list>

    <v-layout class="version-number" justify-center>
      <small style="height: 100%">
        <span v-if="!mini">Versão </span>
        <span>{{ $store.getters.appVersion }}</span>
      </small>
    </v-layout>
  </v-navigation-drawer>
</template>

<script>
import { mapMutations, mapState } from "vuex";

export default {
  created() {
    let vm = this;

    let interval = setInterval(function () {
      if (vm.$store.getters.getLoggedUser) {
        vm.loggedUser = vm.$store.getters.getLoggedUser;
        clearInterval(interval);
      }
    }, 100);

    for (let i = 0; i < this.links.length; i++) {
      if (this.links[i].group && this.groupActive(this.links[i].children)) {
        this.openGroupIndex = i;
        break;
      }
    }
  },
  props: {
    opened: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      drawer: true,
      mini: true,
      loggedUser: {},
      openGroupIndex: null,
      links: [
        {
          to: "/dashboard",
          icon: "mdi-view-dashboard",
          text: ["Dashboard", "Clientes"],
          group: false,
        },
        {
          to: "/creditors-info",
          icon: "mdi-domain",
          text: ["Informações Dos Credores"],
        },
        {
          to: "/notifications",
          icon: "mdi-send",
          text: ["Disparos"],
          group: false,
        },
        {
          to: "",
          icon: "mdi-strategy",
          text: [
            "Estratégia manual",
            "Sob demanda",
            "Planejamento",
            "Arquivados",
            "Abordagens",
            "Abordagem",
          ],
          group: true,
          children: [
            {
              to: "/strategies/production",
              icon: "miscellaneous_services",
              text: ["Sob demanda"],
            },
            {
              to: "/strategies/planning",
              icon: "fact_check",
              text: ["Planejamento"],
            },
            {
              to: "/strategies/archived",
              icon: "archive",
              text: ["Arquivados"],
            },
            {
              to: "/approaches",
              icon: "mdi-voice",
              text: ["Abordagens", "Abordagem"],
              group: false,
            },
            {
              to: "/notifications-history",
              icon: "mdi-send-clock",
              text: ["Histórico de disparos"],
              group: false,
            },
          ],
        },
        {
          to: "",
          icon: "mdi-tree",
          text: [
            "Estratégia inteligente",
            "Visualização",
            "Administração",
            "Fluxos de abordagem",
          ],
          group: true,
          children: [
            {
              to: "/debt-tree/view",

              icon: "mdi-file-tree",
              text: ["Segmentação da carteira", "Árvore view"],
            },
            {
              to: "/debt-tree/stimulus",
              icon: "mdi-finance",
              text: ["Estímulos", "Árvore admin"],
            },
            {
              to: "/debt-tree/approach-flow",
              icon: "mdi-forum",
              text: ["Fluxos de abordagem"],
            },
            {
              to: "/debt-tree/stimulus-history",
              icon: "mdi-send-clock",
              text: ["Histórico de estímulos"],
              group: false,
            },
            {
              to: "/debt-tree/prepares-daily",
              icon: "mdi-clock-out",
              text: ["Previsão dos preparos do dia"],
              group: false,
            },
          ],
        },
        {
          to: "",
          icon: "mdi-state-machine",
          text: ["Incentivos Automáticos"],
          group: true,
          children: [
            {
              to: "/incentive-approach",
              icon: "mdi-playlist-check",
              text: ["Abordagens de Incentivo"],
              group: false,
            },
            {
              to: "/incentive-firings",
              icon: "mdi-send-check",
              text: ["Disparos de Incentivos"],
              group: false,
            },
          ],
        },
        {
          to: "",
          icon: "mdi-whatsapp",
          text: ["WhatsApp"],
          group: true,
          children: [
            {
              to: "/initiatives",
              icon: "send_to_mobile",
              text: ["Gerenciador de iniciativas"],
              group: false,
            },
            {
              to: "/senders",
              icon: "mdi-phone-outgoing",
              text: ["Senders"],
              group: false,
            },
          ],
        },
        {
          to: "",
          icon: "engineering",
          text: ["Administração", "Orçamento", "Pools de sms"],
          group: true,
          children: [
            {
              to: "/administration-forecast",
              icon: "attach_money",
              text: ["Previsão mensal por credor"],
            },
            {
              to: "/administration-event",
              icon: "event_note",
              text: ["Gestão dos eventos"],
            },
            {
              to: "/administration-potential",
              icon: "insights",
              text: ["Gestão dos potenciais"],
            },
            {
              to: "/pools",
              icon: "mdi-cellphone-message",
              text: ["Pools de sms"],
              group: false,
            },
            {
              to: "/reporting-history",
              icon: "pending_actions",
              text: ["Histórico de relatórios"],
              group: false,
            },
          ],
        },
      ],
    };
  },
  computed: {
    ...mapState("app", ["image", "color"]),
    inputValue: {
      get() {
        return this.$store.state.app.drawer;
      },
      set(val) {
        this.setDrawer(val);
      },
    },
  },
  watch: {
    mini() {
      if (this.mini) {
        document.getElementById("minDialog").style.left = "60px";
      } else {
        document.getElementById("minDialog").style.left = "310px";
      }
    },
  },
  methods: {
    ...mapMutations("app", ["setDrawer", "toggleDrawer"]),
    expandDrawer() {
      this.mini = false;
    },
    collapseDrawer() {
      this.mini = true;
    },
    onGroupInput(index, isOpen) {
      this.openGroupIndex = isOpen ? index : null;
    },
    active(arr) {
      return arr.indexOf(this.$route.name) == -1 ? "" : "menu-active";
    },
    groupActive(arrs) {
      for (let i = 0; i < arrs.length; i++)
        if (arrs[i].text.indexOf(this.$route.name) != -1) return true;

      return false;
    },
  },
};
</script>

<style lang="scss">
#app-drawer {
  .v-list__tile {
    border-radius: 4px;

    &--buy {
      margin-top: auto;
      margin-bottom: 17px;
    }
  }
}

.v-navigation-drawer {
  height: 100%;
  z-index: 6;

  .v-avatar {
    margin-left: -10px;
  }

  &.mini {
    .v-list__tile {
      justify-content: center;
    }
    .v-avatar {
      cursor: pointer;
      width: 30px !important;
      height: 30px !important;
      margin-left: 0px;
      &:hover {
        filter: brightness(110%);
      }
    }
  }

  .version-number {
    text-align: center;
    white-space: nowrap;
    color: rgba(0, 0, 0, 0.8);
    position: absolute;
    bottom: 0;
    left: 50%;
    right: 50%;
    padding-bottom: 4px;
  }

  .clickable {
    cursor: pointer;
  }
}

.menu-active {
  background-color: rgba($color: #000, $alpha: 0.1) !important;
  .primary--text {
    color: #ff4081 !important;
  }
}

.v-list__tile--active .primary--text {
  color: "red" !important;
}

.v-avatar {
  margin-left: -10px;
}

.v-list__group__header .v-list__group__header__prepend-icon {
  min-width: auto !important;
}

.v-list__group--active.menu-group-active {
  background: linear-gradient(to bottom, #d0d0d0, #dcdcdc) !important;
}
#nav-drawer {
  background: linear-gradient(to bottom, #f0f0f0, #dcdcdc) !important;
  box-shadow: 4px 0 12px rgba(0, 0, 0, 0.15) !important;
}
.v-navigation-drawer .v-list {
  background: transparent !important;
}
</style>
